import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var e = {
  data: ""
},
    t = function t(_t) {
  return "object" == typeof window ? ((_t ? _t.querySelector("#_goober") : window._goober) || Object.assign((_t || document.head).appendChild(document.createElement("style")), {
    innerHTML: " ",
    id: "_goober"
  })).firstChild : _t || e;
},
    r = function r(e) {
  var r = t(e),
      l = r.data;
  return r.data = "", l;
},
    l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
    a = /\/\*[^]*?\*\/|  +/g,
    n = /\n+/g,
    o = function o(e, t) {
  var r = "",
      l = "",
      a = "";

  var _loop = function _loop(_n2) {
    var c = e[_n2];
    "@" == _n2[0] ? "i" == _n2[1] ? r = _n2 + " " + c + ";" : l += "f" == _n2[1] ? o(c, _n2) : _n2 + "{" + o(c, "k" == _n2[1] ? "" : t) + "}" : "object" == typeof c ? l += o(c, t ? t.replace(/([^,])+/g, function (e) {
      return _n2.replace(/(^:.*)|([^,])+/g, function (t) {
        return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
      });
    }) : _n2) : null != c && (_n2 = /^--/.test(_n2) ? _n2 : _n2.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(_n2, c) : _n2 + ":" + c + ";");
    _n = _n2;
  };

  for (var _n in e) {
    _loop(_n);
  }

  return r + (t && a ? t + "{" + a + "}" : a) + l;
},
    c = {},
    s = function s(e) {
  if ("object" == typeof e) {
    var _t2 = "";

    for (var _r in e) {
      _t2 += _r + s(e[_r]);
    }

    return _t2;
  }

  return e;
},
    i = function i(e, t, r, _i, p) {
  var u = s(e),
      d = c[u] || (c[u] = function (e) {
    var t = 0,
        r = 11;

    for (; t < e.length;) {
      r = 101 * r + e.charCodeAt(t++) >>> 0;
    }

    return "go" + r;
  }(u));

  if (!c[d]) {
    var _t3 = u !== e ? e : function (e) {
      var t,
          r,
          o = [{}];

      for (; t = l.exec(e.replace(a, ""));) {
        t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
      }

      return o[0];
    }(e);

    c[d] = o(p ? _defineProperty({}, "@keyframes " + d, _t3) : _t3, r ? "" : "." + d);
  }

  return function (e, t, r) {
    -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
  }(c[d], t, _i), d;
},
    p = function p(e, t, r) {
  return e.reduce(function (e, l, a) {
    var n = t[a];

    if (n && n.call) {
      var _e = n(r),
          _t4 = _e && _e.props && _e.props.className || /^go/.test(_e) && _e;

      n = _t4 ? "." + _t4 : _e && "object" == typeof _e ? _e.props ? "" : o(_e, "") : !1 === _e ? "" : _e;
    }

    return e + l + (null == n ? "" : n);
  }, "");
};

function u(e) {
  var r = this || {},
      l = e.call ? e(r.p) : e;
  return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce(function (e, t) {
    return Object.assign(e, t && t.call ? t(r.p) : t);
  }, {}) : l, t(r.target), r.g, r.o, r.k);
}

var d,
    f,
    g,
    b = u.bind({
  g: 1
}),
    h = u.bind({
  k: 1
});

function m(e, t, r, l) {
  o.p = t, d = e, f = r, g = l;
}

function j(e, t) {
  var r = this || {};
  return function () {
    var l = arguments;

    function a(n, o) {
      var c = Object.assign({}, n),
          s = c.className || a.className;
      r.p = Object.assign({
        theme: f && f()
      }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
      var i = e;
      return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
    }

    return t ? t(a) : a;
  };
}

export { u as css, r as extractCss, b as glob, h as keyframes, m as setup, j as styled };